import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';
import type { TimelineFilters } from '../types/Timeline';

export function useTimeline(filters: TimelineFilters) {
  return useQuery(allocationQueries.timeline(filters));
}
